import {ID} from '../../../global'
import {ReactNode} from 'react'

interface ModalInterface {
  button: {
    tooltip: string
    text?: string
    bg: string
    icon: {
      show: boolean
      svg: string
    }
  },
  modal: {
    id: string
    size: 'sm' | 'md' | 'lg' | 'xl'
    content: ReactNode
  }
}

interface ModalNoteInterface {
  notes: string
  id: string
  textIcon: boolean
  size: 'sm' | 'md' | 'lg' | 'xl'
}

interface ModalStatusInterface {
  status: string
  id: string
  textIcon: boolean
  size: 'sm' | 'md' | 'lg' | 'xl'
}

interface AddToContactsInterface {
  index: ID
  textIcon: boolean
  initialValues: InitialValuesAddToContactsInterface
  triggerReload: () => void;
}

interface InitialValuesAddToContactsInterface {
  first_name: string,
  last_name: string,
  email: string,
  number: string,
  companyName: string,
  street: string,
}

interface initialValuesCreateTicketType {
  subject: string
  products: string
  assigns?: string
  assignTitle?: string;
  description: string
  files: File[]
}

const initialValuesCreateTicket: initialValuesCreateTicketType = {
  subject: '',
  products: '',
  description: '',
  files: [] as File[],
}

export type {
  ModalInterface,
  ModalNoteInterface,
  ModalStatusInterface,
  AddToContactsInterface,
  InitialValuesAddToContactsInterface,
  initialValuesCreateTicketType
}

export {
  initialValuesCreateTicket
}